$(document).ready(function () {
    if ($('.history').length === 0) return;

    $('.history_preview .history__item').click(function () {
        $('.history_preview').slick('slickGoTo', parseInt($(this).attr('data-slick-index')));
    });

    $('.history__item-wrap').on('afterChange', function (slick, currentSlide) {
        $(this).siblings('.history__counter').find('span').text(currentSlide.currentSlide + 1);
    });

});